/*
 * School Management System API
 * APIs for managing branches, employees, students, receipts, etc.
 *
 * OpenAPI spec version: 1.0.0
 * Contact: tejabhargavpodila@gmail.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.54
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The Branch model module.
 * @module model/Branch
 * @version 1.0.0
 */
export default class Branch {
  /**
   * Constructs a new <code>Branch</code>.
   * @alias module:model/Branch
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>Branch</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/Branch} obj Optional instance to populate.
   * @return {module:model/Branch} The populated <code>Branch</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new Branch();
      if (data.hasOwnProperty('branchName'))
        obj.branchName = ApiClient.convertToType(data['branchName'], 'String');
      if (data.hasOwnProperty('branchCode'))
        obj.branchCode = ApiClient.convertToType(data['branchCode'], 'String');
      if (data.hasOwnProperty('branchAddress'))
        obj.branchAddress = ApiClient.convertToType(data['branchAddress'], 'String');
    }
    return obj;
  }
}

/**
 * @member {String} branchName
 */
Branch.prototype.branchName = undefined;

/**
 * @member {String} branchCode
 */
Branch.prototype.branchCode = undefined;

/**
 * @member {String} branchAddress
 */
Branch.prototype.branchAddress = undefined;

